import { bindEmitterMethod } from 'helpers/bind';
import Component, { forceArray } from 'navigation/component/Component';
import ReturnsItemRow from './ReturnsItemRow';
export default class ReturnsItem extends Component {
    initialized() {
        super.initialized();
    }
    getModulesMap() {
        return {
            rows: ['.returns__item-row', ReturnsItemRow]
        };
    }
    bindEvents(add) {
        const emitterMethod = bindEmitterMethod(add);
        if (this.modules.rows) {
            forceArray(this.modules.rows).forEach((row) => {
                row[emitterMethod]('update:choice', this.handleItemChoiceUpdate);
                row[emitterMethod]('update:reason', this.handleItemReasonUpdate);
                row[emitterMethod]('update:size', this.handleUpdateSize);
                row[emitterMethod]('update:color', this.handleUpdateColor);
            });
        }
    }
    handleItemChoiceUpdate = (value) => {
        this.emit('update:choice', value);
    };
    handleItemReasonUpdate = (value) => {
        this.emit('update:reason', value);
    };
    handleUpdateSize = (value) => {
        this.emit('update:size', value);
    };
    handleUpdateColor = (value) => {
        this.emit('update:color', value);
    };
}
